import { AppointmentPhase } from "components";
import { PhosphorWarningInline } from "components/Atoms/PhosphorIcon";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import React from "react";
import CostSalesForList from "show/components/CostSalesForList";
import { DateTimeAndStatus, VenuePromoterHotel } from "show/list/cardLayout";
import { ShowSidePanel } from "components/SidePanel/Show/ShowSidePanel";

const Name = ({ show }: { show: server.dto.ShowForListExternal }) => {
  const eventName = show.eventName || "...";
  const artistName = site.currentEnvironment.functionGroups.artist.enabled && (show.artist) ? `${show.artist.name} | ` : null;

  return <>
    <ShowSidePanel
      canEdit={false}
      showId={show.showId}
      trigger={<LargeClickableTitle
        icon={<AppointmentPhase value={show.status.appointmentPhase} displayLabel={false} />}
        title={<>
          {!show.validated && <PhosphorWarningInline />}
          {artistName}{eventName}
        </>}
      />}
    />
    {show.productionName && <div>{show.productionName}</div>}
  </>
};

const Financial = ({ show }: { show: server.dto.ShowForListExternal }) => {
  const hasCosts = site.permissions.show.canReadCosts && (show.costsExcludingTax) && show.costsExcludingTax.amount !== 0;
  const hasSales = site.permissions.show.canReadSales && (show.salesExcludingTax) && show.salesExcludingTax.amount !== 0;

  return <div className="flex-column gap-larger" style={{ flex: "0 1 180px" }}>
    <div className="flex-column gap-small">
      {hasCosts && <div className="flex">
        <span className="show-list-card-label grow1">{RESX.Financial.Costs}</span>
        <span><CostSalesForList value={show.costsExcludingTax} baseCurrencyFormat="hidden" /></span>
      </div>}
      {hasSales && <div className="flex">
        <span className="show-list-card-label grow1">{RESX.Financial.Sales}</span>
        <span><CostSalesForList value={show.salesExcludingTax} baseCurrencyFormat="hidden" /></span>
      </div>}
    </div>
  </div>;
};

export const cardLayout = (_: server.viewmodel.ShowListExternalFrontModel): ListTemplateLayout<server.dto.ShowForListExternal> => ({
  type: "card",
  sections: {
    renderTitle: show => <Name show={show} />,
    hideTitle: () => false,
    renderBody: show => <>
      <DateTimeAndStatus show={show} />
      <VenuePromoterHotel show={show} />
      <Financial show={show} />
    </>,
    renderFooter: () => null,
    hideFooter: () => true
  }
});